import GoogleStructuredData from './GoogleStructuredData';

export default GoogleStructuredData;
